import React from "react";

const TabPane = ({ children }) => {
  return <div className="tab-pane">{children}</div>;
};

export default TabPane;
